var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.18 6.11997C13.9867 5.81331 13.78 5.52664 13.5667 5.25997C13.32 4.94664 12.8533 4.91997 12.5733 5.19997L10.5733 7.19997C10.72 7.63997 10.7467 8.14664 10.6133 8.67331C10.38 9.61331 9.62001 10.3733 8.68001 10.6066C8.15334 10.74 7.64667 10.7133 7.20667 10.5666C7.20667 10.5666 6.25334 11.52 5.56667 12.2066C5.23334 12.54 5.34001 13.1266 5.78667 13.3C6.50001 13.5733 7.24001 13.7133 8.00001 13.7133C9.18667 13.7133 10.34 13.3666 11.3933 12.72C12.4667 12.0533 13.4333 11.0733 14.2133 9.82664C14.8467 8.81997 14.8133 7.12664 14.18 6.11997Z",
    fill: "#51525C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34666 6.65332L6.65332 9.34666C6.31332 8.99999 6.09332 8.51999 6.09332 7.99999C6.09332 6.95332 6.94666 6.09332 7.99999 6.09332C8.51999 6.09332 8.99999 6.31332 9.34666 6.65332Z",
    fill: "#51525C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1666 3.83335L9.90665 6.09335C9.41998 5.60002 8.74665 5.30668 7.99998 5.30668C6.50665 5.30668 5.30665 6.51335 5.30665 8.00001C5.30665 8.74668 5.60665 9.42001 6.09331 9.90668L3.83998 12.1667H3.83331C3.09331 11.5667 2.41331 10.8 1.83331 9.89335C1.16665 8.84668 1.16665 7.14668 1.83331 6.10001C2.60665 4.88668 3.55331 3.93335 4.60665 3.28002C5.65998 2.64002 6.81331 2.28668 7.99998 2.28668C9.48665 2.28668 10.9266 2.83335 12.1666 3.83335Z",
    fill: "#51525C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90666 7.99999C9.90666 9.04666 9.05332 9.90666 7.99999 9.90666C7.95999 9.90666 7.92666 9.90666 7.88666 9.89332L9.89332 7.88666C9.90666 7.92666 9.90666 7.95999 9.90666 7.99999Z",
    fill: "#51525C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5133 1.48667C14.3133 1.28667 13.9867 1.28667 13.7867 1.48667L1.48667 13.7933C1.28667 13.9933 1.28667 14.32 1.48667 14.52C1.58667 14.6133 1.71334 14.6667 1.84667 14.6667C1.98 14.6667 2.10667 14.6133 2.20667 14.5133L14.5133 2.20667C14.72 2.00667 14.72 1.68667 14.5133 1.48667Z",
    fill: "#51525C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.f80f4ab0a7df98b03de561226c093f59.svg";
export { ForwardRef as ReactComponent };